import { useMemo, useState } from 'react'
import { Box, Breadcrumbs, Typography, Stack, Button, Chip } from '@mui/material'
import { Add } from '@mui/icons-material'
import { DataGrid, type GridColDef } from '@mui/x-data-grid'
import { useQuery } from '@tanstack/react-query'
import { listPickingLists, type PickingListListItem } from '../../api/logistica'
import CreatePickingListDialog from './CreatePickingListDialog'
import PickingListDetailDialog from './PickingListDetailDialog'

export default function PickingListsPage() {
  const [createOpen, setCreateOpen] = useState(false)
  const [detailId, setDetailId] = useState<string | null>(null)
  const { data, isLoading } = useQuery({ queryKey: ['logistica', 'picking'], queryFn: listPickingLists })

  const columns = useMemo<GridColDef<PickingListListItem>[]>(() => [
    { field: 'number', headerName: 'Nr.', width: 140, renderCell: (p) => <code>{p.row.number}</code> },
    { field: 'orderNumber', headerName: 'Comandă', width: 140 },
    { field: 'clientName', headerName: 'Client', flex: 1, minWidth: 180 },
    {
      field: 'status', headerName: 'Status', width: 130, sortable: false,
      renderCell: (p) => <Chip size="small" label={p.row.status === 'Draft' ? 'Ciornă' : 'Confirmată'} color={p.row.status === 'Draft' ? 'default' : 'success'} variant="outlined" />,
    },
    { field: 'createdAt', headerName: 'Creat la', width: 160, valueFormatter: (v: string) => new Date(v).toLocaleString('ro-RO') },
  ], [])

  return (
    <Stack spacing={2}>
      <Breadcrumbs separator="/" sx={{ fontSize: 12.5 }}>
        <Typography variant="inherit" color="text.secondary">Logistică</Typography>
        <Typography variant="inherit" color="text.primary">Picking și packing</Typography>
      </Breadcrumbs>
      <Typography variant="h2">Picking și packing</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="contained" startIcon={<Add />} onClick={() => setCreateOpen(true)}>Listă de picking nouă</Button>
      </Box>
      <Box sx={{ height: 560, bgcolor: 'background.paper', borderRadius: 1.5 }}>
        <DataGrid rows={data ?? []} columns={columns} loading={isLoading} density="comfortable" disableRowSelectionOnClick
          onRowClick={(p) => setDetailId(p.row.id)}
          initialState={{ pagination: { paginationModel: { pageSize: 25 } } }} pageSizeOptions={[25, 50]} />
      </Box>

      <CreatePickingListDialog open={createOpen} onClose={() => setCreateOpen(false)} onCreated={(id) => { setCreateOpen(false); setDetailId(id) }} />
      <PickingListDetailDialog id={detailId} onClose={() => setDetailId(null)} />
    </Stack>
  )
}
